'use strict';

require('../../style/index.less');

require('./index.less');

require('../../tooltip/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/slider/style/index.tsx
 ** module id = 339
 ** module chunks = 0
 **/